import React from 'react'
import { colors, borderRadius } from '../../styles/tokens'

/**
 * Lista de arquivos anexados
 * 
 * Single Responsibility: Exibir arquivos com opção de remover
 */
export default function AttachedFiles({ files, onRemove }) {
  if (files.length === 0) return null

  return (
    <div style={{
      padding: '1rem 1.5rem',
      borderBottom: `1px solid ${colors.border}`,
      display: 'flex',
      flexWrap: 'wrap',
      gap: '0.5rem'
    }}>
      {files.map((file, i) => (
        <div key={i} style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          padding: '0.5rem 0.75rem',
          backgroundColor: colors.background,
          borderRadius: borderRadius.sm,
          fontSize: '0.875rem'
        }}>
          <span>📎</span>
          <span style={{ 
            color: colors.text.primary, 
            maxWidth: '150px', 
            overflow: 'hidden', 
            textOverflow: 'ellipsis', 
            whiteSpace: 'nowrap' 
          }}>
            {file.name}
          </span>
          <button
            onClick={() => onRemove(i)}
            style={{
              background: 'none',
              border: 'none',
              color: colors.text.secondary,
              cursor: 'pointer',
              padding: '0 0.25rem'
            }}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  )
}
